angular.module('lsnBase.deprecated.models')
  .factory('AddressModelConstants', ['LsnAddressModelConstants', function(LsnAddressModelConstants) {
    return LsnAddressModelConstants;
  }])
  .factory('AddressModel', ['LsnAddressModelV1',
    function(LsnAddressModelV1) {
      return LsnAddressModelV1;
    }
  ]);